/**
 * Fire event when the viewport is at a predefined size.
 */

define('libs/viewportmanager',[],function() {

    'use strict';

    var SETTINGS = {
        /**
         * Breakpoints should match those defined in the css.
         */
        breakpoints: {
            MOBILE: 0,
            PORTABLE: 760,
            DESKTOP: 990
        }
    };

    var EVENTS = {
        VIEWPORT_CHANGE: 'viewport.change'
    };

    var ViewportManager = function(settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});

        // add the resizing listener to the viewport.
        $(window).on('resize', this.checkViewport.bind(this));

        // do the initial check.
        this.checkViewport();
    };

    /**
     * Viewport size changes.
     * Check for size changes of the viewport.
     */
    ViewportManager.prototype.checkViewport = function() {
        var viewport = this.getViewport((document.documentElement || document.body).clientWidth);
        if (viewport != this.viewport) {
            this.viewport = viewport;
            $(window).trigger(EVENTS.VIEWPORT_CHANGE, viewport);
        }
    };

    /**
     * Get the current viewport (mobile, desktop etc.).
     * @param {Number} size The size of the current viewport.
     * @return {String} The type of viewport.
     */
    ViewportManager.prototype.getViewport = function(size) {
        var viewport = '';
        for (var type in this.settings.breakpoints) {
            if (this.settings.breakpoints.hasOwnProperty(type) &&
                size >= this.settings.breakpoints[type] &&
                this.settings.breakpoints[type] >= (this.settings.breakpoints[viewport] || 0)) {
                viewport = type;
            }
        }

        return viewport;
    };

    return ViewportManager;
});

